document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const button = form && form.querySelector('[data-add-button]');
  const price = document.querySelector('[data-product-price]');
  const option = select.options[select.selectedIndex];
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.querySelector('span').textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.querySelectorAll('[data-recommendations-url]').forEach((section) => {
  const load = () => fetch(section.dataset.recommendationsUrl)
    .then((response) => response.text())
    .then((text) => {
      const holder = document.createElement('div');
      holder.innerHTML = text;
      const replacement = holder.querySelector('[data-recommendations-url]');
      if (replacement && replacement.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect(); load();
    }, { rootMargin: '0px 0px 300px' });
    observer.observe(section);
  } else load();
});

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const menu = document.getElementById(button.getAttribute('aria-controls'));
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    if (menu) menu.hidden = expanded;
  });
});
